export default "__VITE_ASSET__f8992db5__"